(function () {
  'use strict';

  if (window.__rsPerformanceCoreInstalled) return;
  window.__rsPerformanceCoreInstalled = true;

  function optimizeProductBlockLoading() {
    var ProductBlock = window.customElements && window.customElements.get('product-block');
    if (!ProductBlock || ProductBlock.prototype.__rsPerformanceOptimized) return;

    ProductBlock.prototype.__rsPerformanceOptimized = true;

    ProductBlock.prototype.initCustomLazyLoading = function () {
      var self = this;

      function activateHoverImage() {
        var hoverImage = self.querySelector(
          '.product-block__image--show-on-hover.product-block__image--inactivated'
        );

        if (hoverImage) {
          hoverImage.classList.remove('product-block__image--inactivated');
        }

        if (self.__rsHoverImageObserver) {
          self.__rsHoverImageObserver.disconnect();
          self.__rsHoverImageObserver = null;
        }
      }

      if ('IntersectionObserver' in window) {
        this.__rsHoverImageObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            activateHoverImage();
          }
        }, {
          rootMargin: '140px 0px',
          threshold: 0
        });

        this.__rsHoverImageObserver.observe(this);
      } else {
        window.setTimeout(activateHoverImage, 1500);
      }

      this.boundLazyLoadAll = this.lazyLoadAll.bind(this);
      this.addEventListener('mouseenter', this.boundLazyLoadAll, { once: true });
      this.addEventListener('touchstart', this.boundLazyLoadAll, { passive: true, once: true });
    };
  }

  function installLeanCartSync() {
    window.onpageshow = function (event) {
      var navEntries = window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType('navigation')
        : [];
      var navEntry = navEntries && navEntries[0];
      var restoredFromHistory = Boolean(
        (event && event.persisted) ||
        (navEntry && navEntry.type === 'back_forward')
      );

      if (!restoredFromHistory) return;

      function syncCart() {
        fetch(theme.routes.cart + '.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
            return response.json();
          })
          .then(function (data) {
            var cartLink = document.querySelector('.cart-link');
            if (!cartLink || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return;

            var cartString = data.items.map(function (item) {
              return item.key + '|' + item.quantity;
            }).join(',');
            var cartUint8 = new TextEncoder().encode(cartString);

            return window.crypto.subtle.digest('SHA-256', cartUint8).then(function (buffer) {
              var hash = Array.from(new Uint8Array(buffer)).map(function (value) {
                return value.toString(16).padStart(2, '0');
              }).join('');

              if (hash !== cartLink.dataset.hash) {
                document.dispatchEvent(new CustomEvent('on:cart:change', {
                  bubbles: true,
                  cancelable: false
                }));
              }
            });
          })
          .catch(function () {
            // Cart synchronization is a resilience check only.
          });
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(syncCart, { timeout: 900 });
      } else {
        window.setTimeout(syncCart, 180);
      }
    };
  }

  function removeSupplierReferencesFromSizeGuide() {
    var guide = document.getElementById('rs-size-guide');
    if (!guide) return;

    var replacements = [
      ['Printegy-Artikel', 'Artikel'],
      ['Material laut Printegy:', 'Material:'],
      ['Printegy führt ihn in S–XXL;', 'Er ist in S–XXL erhältlich;'],
      ['articles Printegy', 'articles'],
      ['Matière selon Printegy :', 'Matière :'],
      ['Printegy le propose du S au XXL ;', 'Il est disponible du S au XXL ;'],
      ['Printegy-artikelen', 'artikelen'],
      ['Materiaal volgens Printegy:', 'Materiaal:'],
      ['Printegy biedt dit model aan in S–XXL;', 'Het is verkrijgbaar in S–XXL;'],
      ['Printegy items', 'items'],
      ['Material according to Printegy:', 'Material:'],
      ['Printegy offers it in S–XXL;', 'It is available in S–XXL;']
    ];

    guide.querySelectorAll('[data-rs-size-text]').forEach(function (element) {
      var text = element.textContent || '';
      replacements.forEach(function (replacement) {
        text = text.split(replacement[0]).join(replacement[1]);
      });
      element.textContent = text;
    });
  }

  optimizeProductBlockLoading();
  installLeanCartSync();
  removeSupplierReferencesFromSizeGuide();

  document.addEventListener('shopify:section:load', removeSupplierReferencesFromSizeGuide);
})();
;
(function () {
  'use strict';

  if (window.__rsLeanContentFixesInstalled) return;
  window.__rsLeanContentFixesInstalled = true;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isProductPage() {
    return Boolean(document.body && document.body.classList.contains('template-product'));
  }

  function getProductIdentity() {
    var heading = document.querySelector('main h1, h1');
    return [
      window.location.pathname || '',
      document.title || '',
      heading ? heading.textContent : ''
    ].join(' ').toLowerCase();
  }

  function isJoggerProduct() {
    var identity = getProductIdentity();
    return identity.indexOf('jogger') !== -1 || identity.indexOf('jogginghose') !== -1;
  }

  function needsTurkiyeOrigin() {
    var identity = getProductIdentity();
    return (
      identity.indexOf('jogger') !== -1 ||
      identity.indexOf('jogginghose') !== -1 ||
      identity.indexOf('hoodie') !== -1 ||
      identity.indexOf('zipper') !== -1
    );
  }

  function findProductDetailsContent() {
    var details = document.querySelectorAll('details-disclosure details, main details');
    for (var i = 0; i < details.length; i += 1) {
      var summary = details[i].querySelector('summary');
      if (!summary) continue;
      if (normalizeText(summary.textContent).toLowerCase().indexOf('produktdetails') === -1) continue;
      return details[i].querySelector('.disclosure__content') || details[i];
    }
    return null;
  }

  function findExactSpan(root, text) {
    if (!root) return null;
    var spans = root.querySelectorAll('span');
    for (var i = 0; i < spans.length; i += 1) {
      if (normalizeText(spans[i].textContent) === text) return spans[i];
    }
    return null;
  }

  function removeLegacyModelFitBox() {
    var rows = document.querySelectorAll('main .lightly-spaced-row');
    for (var i = rows.length - 1; i >= 0; i -= 1) {
      var text = normalizeText(rows[i].textContent);
      if (text.indexOf('183 cm | 82 kg | trägt Größe L') === -1) continue;
      if (text.indexOf('Fit: Oversized') === -1) continue;
      rows[i].remove();
    }
  }

  function removeDuplicateFabricWeights() {
    var root = findProductDetailsContent();
    if (!root || root.dataset.rsSingleFabricWeight === 'true') return;

    var weightLabel = findExactSpan(root, 'Gewicht');
    var weightCard = weightLabel ? weightLabel.parentElement : null;
    var fabricWeightLabel = findExactSpan(root, 'Stoffgewicht');

    if (fabricWeightLabel && fabricWeightLabel.parentElement) {
      fabricWeightLabel.parentElement.remove();
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      if (weightCard && weightCard.contains(node)) return;

      var text = node.nodeValue || '';
      if (!/(?:GSM|g\s*\/\s*m(?:²|2))/i.test(text)) return;

      var cleaned = text
        .replace(/schwerer\s+\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))\s+Stoff/gi, 'schwerer Stoff')
        .replace(/griffiger\s+\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))\s+Stoff/gi, 'griffiger Stoff')
        .replace(/Das\s+\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))\s+schwere/gi, 'Das schwere')
        .replace(/\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))\s+schwere/gi, 'schwere')
        .replace(/\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))\s+Stoff/gi, 'Stoff')
        .replace(/\d{2,3}\s*(?:GSM|g\s*\/\s*m(?:²|2))/gi, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([,.;:])/g, '$1');

      if (cleaned !== text) node.nodeValue = cleaned;
    });

    root.dataset.rsSingleFabricWeight = 'true';
  }

  function applyTurkiyeOrigin() {
    if (!needsTurkiyeOrigin()) return;

    var root = findProductDetailsContent();
    if (!root) return;

    var existingLabel = findExactSpan(root, 'Herkunft');
    if (existingLabel && existingLabel.parentElement) {
      var existingSpans = existingLabel.parentElement.querySelectorAll('span');
      if (
        existingSpans.length > 1 &&
        normalizeText(existingSpans[existingSpans.length - 1].textContent) !== 'Türkiye'
      ) {
        existingSpans[existingSpans.length - 1].textContent = 'Türkiye';
      }
      return;
    }

    var compositionLabel = findExactSpan(root, 'Zusammensetzung');
    if (!compositionLabel || !compositionLabel.parentElement || !compositionLabel.parentElement.parentElement) return;

    var detailsContainer = compositionLabel.parentElement.parentElement;
    var rows = detailsContainer.children;
    if (!rows.length) return;

    var originRow = rows[rows.length - 1].cloneNode(true);
    var spans = originRow.querySelectorAll('span');
    if (spans.length < 2) return;

    spans[0].textContent = 'Herkunft';
    spans[spans.length - 1].textContent = 'Türkiye';
    originRow.dataset.rsOriginRow = 'true';
    detailsContainer.appendChild(originRow);
  }

  function findJoggerFitBox() {
    var existing = document.querySelector('[data-rs-jogger-fit="true"]');
    if (existing) return existing;

    var elements = document.querySelectorAll('main div');
    var bestMatch = null;
    var shortestText = Infinity;

    for (var i = 0; i < elements.length; i += 1) {
      var text = normalizeText(elements[i].textContent);
      if (text.length > 500) continue;
      if (text.indexOf('Passform') === -1 || text.indexOf('2 Größen kleiner') === -1) continue;

      if (text.length < shortestText) {
        bestMatch = elements[i];
        shortestText = text.length;
      }
    }

    return bestMatch;
  }

  function applyJoggerFitBox() {
    if (!isJoggerProduct()) return;

    var fitBox = findJoggerFitBox();
    if (!fitBox) return;

    var currentHeading = fitBox.querySelector('[data-rs-jogger-fit-heading]');
    if (
      fitBox.dataset.rsJoggerFit === 'true' &&
      currentHeading &&
      normalizeText(currentHeading.textContent) === 'Fällt ca. zwei Größen größer aus'
    ) {
      return;
    }

    fitBox.innerHTML = '' +
      '<span style="display:block;margin:0 0 7px;font-size:8.8px;line-height:1;text-transform:uppercase;letter-spacing:1.25px;color:#777;font-weight:700;">Passform</span>' +
      '<strong data-rs-jogger-fit-heading style="display:block;margin:0 0 5px;font-size:12.8px;line-height:1.35;color:#151515;font-weight:700;">Fällt ca. zwei Größen größer aus</strong>' +
      '<p style="margin:0;color:#555;font-size:11.2px;line-height:1.52;font-weight:400;"><strong style="color:#151515;font-weight:700;">Empfehlung:</strong> Wähle 2 Größen kleiner als gewöhnlich. Für einen extra lockeren Fit genügt eine Größe kleiner.</p>' +
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin:10px 0 0;padding:9px 0 0;border-top:1px solid #ededed;">' +
        '<span style="font-size:10.5px;line-height:1.35;color:#666;">Großzügiger Jogger-Fit · elastischer Bund</span>' +
        '<a href="/pages/grossentabelle#jogger" target="_blank" rel="noopener" style="font-size:10.6px;line-height:1.35;color:#151515;font-weight:600;text-decoration:none;border-bottom:1px solid #999;padding-bottom:1px;">Größentabelle ansehen →</a>' +
      '</div>';

    fitBox.style.width = '100%';
    fitBox.style.margin = '0 0 -12px 0';
    fitBox.style.padding = '13px 14px';
    fitBox.style.border = '1px solid #e6e6e6';
    fitBox.style.borderRadius = '4px';
    fitBox.style.background = '#ffffff';
    fitBox.style.fontFamily = "'Jost', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
    fitBox.style.boxSizing = 'border-box';
    fitBox.style.color = '#151515';
    fitBox.style.position = 'relative';
    fitBox.style.zIndex = '10';
    fitBox.dataset.rsJoggerFit = 'true';
  }

  function applyProductEnhancements() {
    if (!isProductPage()) return;
    removeLegacyModelFitBox();
    applyJoggerFitBox();
    removeDuplicateFabricWeights();
    applyTurkiyeOrigin();
  }

  function initialize() {
    if (!isProductPage()) return;
    window.requestAnimationFrame(applyProductEnhancements);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('variant-picker, .section-main-product')) {
      window.requestAnimationFrame(applyProductEnhancements);
    }
  });

  var styleId = 'rs-mobile-sale-menu-color';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = '@media screen and (max-width:989px){.mobile-navigation-drawer a[href="/collections/sale"],.mobile-navigation-drawer a[href$="/collections/sale"],.mobile-navigation-drawer a[href^="/collections/sale?"]{color:#d60000!important;font-weight:800!important;}}';
    document.head.appendChild(style);
  }
})();
;
(function () {
  'use strict';

  if (window.__rsCartGuardInstalled) return;
  window.__rsCartGuardInstalled = true;

  var WARNING_CLASS = 'rs-cart-guard-warning';
  var MISSING_CLASS = 'rs-cart-guard-missing';

  function installStyles() {
    if (document.getElementById('rs-cart-guard-styles')) return;

    var style = document.createElement('style');
    style.id = 'rs-cart-guard-styles';
    style.textContent = '' +
      '.' + WARNING_CLASS + '{display:flex!important;align-items:flex-start;gap:10px;margin:0 0 14px!important;padding:12px 13px!important;border:2px solid #d92d20!important;border-radius:5px!important;background:#fff1f0!important;color:#7a271a!important;font-size:13px!important;line-height:1.45!important;font-weight:700!important;box-sizing:border-box!important;}' +
      '.' + WARNING_CLASS + '[hidden]{display:none!important;}' +
      '.' + WARNING_CLASS + '__icon{font-size:18px;line-height:1;flex:0 0 auto;}' +
      '.option-selector.' + MISSING_CLASS + '{outline:3px solid #d92d20!important;outline-offset:4px!important;border-radius:3px!important;}' +
      '.option-selector.' + MISSING_CLASS + ' .label{color:#b42318!important;}' +
      '.option-selector.' + MISSING_CLASS + ' .opt-label{border-color:#d92d20!important;}' +
      '@media(max-width:767px){.' + WARNING_CLASS + '{font-size:12px!important;padding:11px!important;}}';
    document.head.appendChild(style);
  }

  function closestScope(node) {
    return node.closest('.js-quickbuy, product-form, .js-product, .section-main-product, sticky-atc') || document;
  }

  function getPicker(scope) {
    var picker = scope.querySelector('variant-picker');
    if (picker) return picker;

    var section = scope.closest && scope.closest('.shopify-section');
    return section ? section.querySelector('variant-picker') : null;
  }

  function getForm(origin, scope) {
    if (origin && origin.matches && origin.matches('form')) return origin;
    return (origin && origin.form) ||
      (origin && origin.closest && origin.closest('form')) ||
      scope.querySelector('.js-product-form');
  }

  function getSelectors(picker) {
    if (!picker) return [];
    return Array.prototype.slice.call(
      picker.querySelectorAll('.option-selector:not(.option-selector--custom)')
    );
  }

  function isSelected(selector) {
    if (selector.dataset.selectorType === 'dropdown') {
      var option = selector.querySelector('.js-option[aria-selected="true"]');
      return Boolean(option && option.dataset.value);
    }
    return Boolean(selector.querySelector('input.js-option:checked'));
  }

  function optionName(selector) {
    var name = (selector.dataset.option || '').trim();
    if (name) return name;

    var label = selector.querySelector('.label, legend');
    return label
      ? label.textContent.replace(/:.*/, '').replace(/\s+/g, ' ').trim()
      : 'Option';
  }

  function joinNames(names) {
    if (names.length === 1) return names[0];
    if (names.length === 2) return names[0] + ' und ' + names[1];
    return names.slice(0, -1).join(', ') + ' und ' + names[names.length - 1];
  }

  function clearState(scope) {
    scope.querySelectorAll('.' + MISSING_CLASS).forEach(function (element) {
      element.classList.remove(MISSING_CLASS);
      element.removeAttribute('aria-invalid');
    });

    scope.querySelectorAll('.' + WARNING_CLASS).forEach(function (element) {
      element.remove();
    });
  }

  function renderWarning(scope, form, message, missingSelectors) {
    clearState(scope);

    missingSelectors.forEach(function (selector) {
      selector.classList.add(MISSING_CLASS);
      selector.setAttribute('aria-invalid', 'true');
    });

    var warning = document.createElement('div');
    warning.className = WARNING_CLASS;
    warning.setAttribute('role', 'alert');
    warning.setAttribute('aria-live', 'assertive');
    warning.innerHTML = '<span class="' + WARNING_CLASS + '__icon" aria-hidden="true">⚠</span><span></span>';
    warning.lastElementChild.textContent = message;

    var row = form && form.querySelector('.quantity-submit-row');
    if (row && row.parentNode) {
      row.parentNode.insertBefore(warning, row);
    } else if (form) {
      form.insertBefore(warning, form.firstChild);
    } else {
      var target = scope.querySelector('.product-form, .detail') || scope;
      if (target && target.insertBefore) {
        target.insertBefore(warning, target.firstChild);
      } else {
        window.alert(message);
      }
    }

    var firstMissing = missingSelectors[0];
    if (firstMissing) {
      window.setTimeout(function () {
        firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var focusTarget = firstMissing.querySelector('input.js-option, button, [tabindex]:not([tabindex="-1"])');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }, 20);
    }
  }

  function validate(origin) {
    var scope = closestScope(origin);
    var picker = getPicker(scope);
    if (!picker) return true;

    var form = getForm(origin, scope);
    var allSelectors = getSelectors(picker);
    var missingSelectors = allSelectors.filter(function (selector) {
      return !isSelected(selector);
    });

    if (missingSelectors.length) {
      renderWarning(
        scope,
        form,
        'Bitte wähle zuerst ' + joinNames(missingSelectors.map(optionName)) + ' aus.',
        missingSelectors
      );
      return false;
    }

    var variantInput = form && form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      renderWarning(
        scope,
        form,
        'Diese Kombination ist derzeit nicht verfügbar. Bitte wähle eine andere Farbe oder Größe.',
        allSelectors
      );
      return false;
    }

    clearState(scope);
    return true;
  }

  function blockAction(event, origin) {
    if (validate(origin)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '.add-to-cart, button[name="add"], .shopify-payment-button__button, .shopify-payment-button button'
    );
    if (button) blockAction(event, button);
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('.js-product-form')) {
      blockAction(event, event.target);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var selector = event.target.closest('.option-selector');
    if (!selector || !selector.closest('variant-picker')) return;

    selector.classList.remove(MISSING_CLASS);
    selector.removeAttribute('aria-invalid');

    var scope = closestScope(selector);
    scope.querySelectorAll('.' + WARNING_CLASS).forEach(function (element) {
      element.remove();
    });
  }, true);

  installStyles();
})();